// export const baseUrl = "http://localhost:4000"
export const baseUrl = "https://movies-ftp.fly.dev"
